import { Box, Switch } from '@material-ui/core';
import { CustomTheme } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { ENV_DARK_MODE } from '@/config/envVars';
import { getTheme } from '@/config/themes/getTheme';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';

export const DarkModeToggle = () => {
  const {
    state: { themeName, darkMode },
    actions: { changeTheme },
  } = useConfigContext();

  const [value, setValue] = useState(darkMode);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!themeName) return;
    const newValue = event.target.checked;
    changeTheme(await getTheme(themeName as CustomTheme, newValue));
    localStorage.setItem(ENV_DARK_MODE, newValue ? 'dark' : 'light');
    setValue(newValue);
  };

  return (
    <Box py={1}>
      <FlexRow width="fit-content" alignItems="flex-start" height={24} gridGap={0}>
        <Switch checked={value} onChange={handleChange} color="primary" name="darkMode" />
        <Font variant="body2" color="textSecondary" display="block">
          <Text tId="DARK_MODE_TOGGLE" />
        </Font>
      </FlexRow>
    </Box>
  );
};
